import { BkWebApp } from 'bk-web-app';
import { Card } from 'bench-internal-theme';
import { openModal } from 'modal-core-components';
import React from 'react';

import CreateOrEditPersonFormContainer from './CreateOrEditPersonFormContainer';

const openCreateOrEditPersonModal = (clientId, person) =>
  openModal(
    closeModal => (
      <Card onDismiss={closeModal}>
        <CreateOrEditPersonFormContainer
          clientId={clientId}
          onPersonSaved={closeModal}
          person={person}
        />
      </Card>
    ),
    BkWebApp,
  );

export default openCreateOrEditPersonModal;
